import { observable, action } from 'mobx';

import agent from './../agent';
import commonStore from './commonStore';
import userStore from './userStore';

class AuthStore {
  @observable inProgress = false;
  @observable error;

  @action
  login(userCode, password) {
    this.inProgress = true;
    this.error = undefined;

    return agent.Auth.login(userCode, password)
      .then(body => commonStore.setToken(body.content))
      .then(() => userStore.updateSelf())
      .catch(
        action(err => {
          const responseBody = err.response.body;
          this.error = { type: responseBody.content, details: responseBody.details || null } || err;
        })
      )
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  }

  @action
  reset() {
    this.inProgress = false;
    this.error = undefined;
  }

  @action
  logout() {
    this.error = undefined;
    this.inProgress = false;
    commonStore.setToken(undefined);
    userStore.forgetUser();
  }
}

export default new AuthStore();



// WEBPACK FOOTER //
// ./src/store/authStore.js